import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { DiscountCalculationType } from '@vista-digital/ocapi-types/v1';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { MemberRewardListContextInstance } from '../types/context';
const b = bemClassBuilder('v-member-reward-list-reward-cost');
export const MemberRewardListRewardCost = observer(props => {
    const i18n = useI18n();
    const { reward } = props;
    const { displayText } = useContext(MemberRewardListContextInstance);
    const { balanceCost } = reward;
    const discount = getRewardDiscount(props.reward, displayText, i18n);
    if (discount)
        return _jsx("span", Object.assign({ className: b.block({ type: 'discount' }) }, { children: discount }));
    if (balanceCost === null || balanceCost === void 0 ? void 0 : balanceCost.units) {
        return (_jsx("div", Object.assign({ className: b.block({ type: 'balanceCost' }) }, { children: i18n.template(displayText.balanceCostFormat, {
                balanceCost: balanceCost === null || balanceCost === void 0 ? void 0 : balanceCost.units
            }) })));
    }
    return null;
});
MemberRewardListRewardCost.displayName = 'MemberRewardListRewardCost';
const getRewardDiscount = (reward, displayText, i18n) => {
    const { discountCalculation } = reward;
    if (!discountCalculation)
        return;
    switch (discountCalculation.type) {
        case DiscountCalculationType.PercentageOff:
            return i18n.template(displayText.percentageOffDiscountFormat, {
                discount: discountCalculation.percentageOff
            });
        case DiscountCalculationType.PriceOff:
            return i18n.template(displayText.priceOffDiscountFormat, {
                discount: i18n.currency(discountCalculation.priceOff)
            });
        case DiscountCalculationType.SpecialPrice:
            return i18n.template(displayText.specialPriceDiscountFormat, {
                price: i18n.currency(discountCalculation.specialPrice)
            });
        default:
            return;
    }
};
